import {Grid, Paper} from "@mui/material";
import React from "react";
import MainMenu from "../../../components/MainMenu";
import TeamList from "../../../components/TeamComponent/TeamList";

const index = () => {
    return (
        <MainMenu>
            <Grid container>
                <Grid item xs={12}>
                    <Paper elevation={3}>
                        <TeamList/>
                    </Paper>
                </Grid>
            </Grid>
        </MainMenu>
    );
};

export default index;
